export default class widgetStickyManager {

    constructor(widget) {
        this.widget = widget;
        this.mouseover = false;
        this.messageStore = {};
        this.restoreChat = false;
        this.hoverOver = false;
        this.configuration = widget.configuration;
        this.elements = {};
        this.elements['tag'] = $('.cbot-chatbotIconTag');
        this.elements['name'] = $('.cbot-chatbotIconName');
        this.elements['speechbubble'] = $('.cbot-chatbotSpeechbubble');
        this.elements['speechbubbleText'] = $('.cbot-chatbotSpeechbubbleText');
        this.elements['speechbubbleClose'] = $('.cbot-chatbotSpeechbubbleClose');
        this.elements['avatar'] = $('#cbot-icon :not(.cbot-chatbotSpeechbubble, .cbot-chatbotSpeechbubble *)');
        this.elements['sticky'] = $('#cbot-icon');
        this.data = {};
        this.elements['avatar'].mouseover(() => { 
            if (!this._data('active') && !this.hoverOver) {
                this.hoverOver = true;
                widget.track("chat", "hover_over", "sticky");
            }
        }); 
        this.elements['avatar'].add(this.elements['speechbubble']).mouseover((event) => { 
            event.stopPropagation();
            if (!this.widget.uic.isMobile()) {
                this.mouseover = true;
                if (this._data('active')) {
                    this.showStickyMessage("activeChat", this.configuration.i18n['balloonActiveChatMessage']);
                }
                else if (this.sticky) {
                    this.showStickyMessage("sticky", this.configuration.i18n['balloonStickyMessage']); 
                } else {
                    this.showStickyMessage("close", this.configuration.i18n['balloonClosedChatMessage']);
                }
            }
        }); 
        this.elements['avatar'].add(this.elements['speechbubble']).mouseout((event) => { 
            event.stopPropagation();
            this.mouseover = false;
            setTimeout(() => {
                if (!this.mouseover && !this.permanentWelcomeMessageActive) {
                    this.hideStickyMessage();
                }
            }, 500);
        }); 
        this.elements['speechbubbleClose'].click(() => {
            this.permanentWelcomeMessageActive = false;
            this.hideStickyMessage();
        });
        this.elements['avatar'].keypress((event) => {
            event.stopPropagation();
            // Accessibility
            if (event.keyCode === 13) {
                $(this).click();
            }
        });
        this.elements['avatar'].click((e) => {
            e.stopPropagation();
            this._chatStart();
        });
        this.welcomeMessageTimeoutAppear = 2000;
        this.welcomeMessageTimeoutDisappear = 5000;
        if (this.configuration && this.configuration.stickySettings) {
            if (this.configuration.stickySettings.showName) {
                this.elements['tag'].text("1");
                this.elements['name'].show();
                this.elements['name'].text(this.configuration.stickySettings.name);

                if (this.configuration.stickySettings.tag && 
                    this.configuration.stickySettings.tag.show) {
                    this.activateTag = true;

                    if(this.configuration.stickySettings.tag.showOnNewSession) {
                        this.elements['tag'].show(); 
                    }
                    if(this.configuration.stickySettings.tag.showOnInactivity) {
                        let inactivityTimeout = this.configuration.stickySettings.tag.inactivityTime;
                        if (inactivityTimeout && isNaN(inactivityTimeout)) {
                            inactivityTimeout = 300000;
                        }    
                        setTimeout(() => {
                            if (!this._data('active')) {
                                this.elements['tag'].show(); 
                            }
                        }, inactivityTimeout);
                    }
                }
            }
            if (this.configuration.stickySettings.welcomeMessage) {
                this.hideWelcomeMessage = this.configuration.stickySettings.welcomeMessage.hideWelcomeMessage ? true : false;
                this.welcomeMessagePermanent = this.configuration.stickySettings.welcomeMessage.permanent ? true : false;
                if (this.configuration.stickySettings.welcomeMessage.timeoutAppear) {
                    this.welcomeMessageTimeoutAppear = this.configuration.stickySettings.welcomeMessage.timeoutAppear; 
                }
                if (this.configuration.stickySettings.welcomeMessage.timeoutDisappear) {
                    this.welcomeMessageTimeoutDisappear = this.configuration.stickySettings.welcomeMessage.timeoutDisappear; 
                }
            }
        }
        this._init();
    }

    /**
     * Start/open a chat session
     */
    _chatStart() {
        this.widget.debug ? console.log("CHAT SPEECH BUBBLE ICON WAS CLICKED") : () => {};
        if(this.widget.uic.active) {
            this.widget.debug ? console.log("MAXIMIZING WINDOW") : () => {};
            this.widget.uic.toggleChatWindowVisibility(true);
        } else {
            this.widget.debug ? console.log("ACTIVATE WIDGET") : () => {};
            this.widget.msgBus.async('InteractionManager.open','chat');
        }
    }

    _data(key, value, dostore) {
        if ('undefined' !== typeof value) {
            this.data[key] = value;
            if (dostore) {
                this.widget.cachingService.setCache('widgetBalloon', this.data);
            }
        }
        return this.data[key];
    }

    _init(forced) {
        if (!!forced || 'undefined' === typeof this._data('pending')) {
            this._data('pending', 0);
            this._data('minimized', true);
            this._data('active', false);
        }
        this.elements['sticky'].show(); 
    }

    _setTagValue(value) {
        if (this.configuration && this.configuration.stickySettings && this.configuration.stickySettings.showName &&
            this.configuration.stickySettings.tag && this.configuration.stickySettings.tag.show) {
                if (value > 3) {
                    value = "3+";
                }
                this.elements['tag'].text(value);
                this.elements['tag'].show();
        }
    }

    _removeTag() {
        this.elements['tag'].text("1");
        this.elements['tag'].hide();
    }

    _parseHTML(message) {
        let html = $.parseHTML(message);
        $.each(html, (i, el) => {
            this._parseInteractiveElements($(el));
        });
        return html;
    }

    _parseInteractiveElements(el) {
        if (el.hasClass('js-cbot-sb-chatStart')) {
            this._createChatStartButton(el);
        }
    }

    _createChatStartButton(el) {
        el.click(() => {
            this.widget.track("chat", "buttonclick", "welcome_message");
            this._chatStart();
        });
    }

    /**
     * THE API
     */

    /**
     * init - public interface to _init
     */
    init() {
        this.data   = this.widget.cachingService.getCache('widgetBalloon');
        this._init();
    }

    /**
     * Set sticky configuration.
     * This is used to show the sticky welcome message
     */
    setSticky() {
        this.sticky = true;
    }

    /**
     * setChatActive - changes the flyover message
     */
    setChatActive(isActive) {
        this._data('active', isActive);
        this.sticky = false;
        this.permanentWelcomeMessageActive = false;
    }

    /**
     * messageReceived - if minimized alerts of pending message(s)
     */
    messageReceived() {
        if (this._data('minimized') && !this.restoreChat) {
            let pending = this._data('pending', this._data('pending')+1);
            this._setTagValue(pending);
        }
    }

    setRestoreChat(restoreChat) {
        this.restoreChat = restoreChat;
    }

    /**
     * minimize - activates or deactivates the flyover
     */
    minimize(isMinimized) {
        if (isMinimized) {
            if (!this._data('minimized')) {
                this._data('minimized', true);
            }
        }
        else {
            if (this._data('minimized')) {
                this._data('pending', 0);
                this._data('minimized', false, true);
                this._removeTag();
            }
        }
    }

    close() {
        this._init(true);
    }

    /**
     * Show sticky message
     * @param {*} key key that identifies the message - message will not be parsed if key already exists
     * @param {*} message string html message that should be parsed and shown
     */
    showStickyMessage(key, message) {
        if (!message || !key) {
            this.hideStickyMessage();
        }
        else {
            if (!this.messageStore[key]) {
                this.messageStore[key] = this._parseHTML(message); 
            } 
            if(this.messageStore.active != key) {
                this.elements['speechbubbleText'].html(this.messageStore[key]); 
            }
            this.messageStore.active = key;
            this.elements['speechbubble'].removeClass('fade-out');
            this.elements['speechbubble'].addClass('fade-in');
        }
    }

    /**
     * Hide currently shown message
     */
    hideStickyMessage() {
        this.elements['speechbubble'].addClass('fade-out');
        this.elements['speechbubble'].removeClass('fade-in');
    }

    /**
     * Shows a welcome message that depending on the configuration vanishes or 
     * stays permanently
     */
    showAlertMessage() {
        setTimeout(() => {
            if (!this._data('active')) {
                this.permanentWelcomeMessageActive = true;
                this.showStickyMessage("sticky", this.configuration.i18n['balloonStickyMessage']);
                if (!this.welcomeMessagePermanent) {
                    setTimeout(() => {
                        this.permanentWelcomeMessageActive = false;
                        if (!this.mouseover) {
                            this.hideStickyMessage();
                        }
                    }, this.welcomeMessageTimeoutDisappear);
                }
            }
        }, this.welcomeMessageTimeoutAppear);
    }

    /**
     *  Hide sticky icon
     * @param {*} onComplete callback when hide animation is finished 
     */
    hideSticky(onComplete) {
        this.elements.sticky.hide({complete: () => onComplete && onComplete()});
    }

    /**
     *  Shows sticky icon  
     * @param {*} onComplete callback when show animation is finished 
     */
    showSticky(onComplete) {
        this.elements.sticky.show({complete: () => onComplete && onComplete()});
    }
}